(() => {
  if (customElements.get('ma-bogo-offer')) return;
  let pending;
  function loadCart() {
    if (!pending) pending = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .finally(() => { pending = null; });
    return pending;
  }
  class MaisonBogoOffer extends HTMLElement {
    connectedCallback() {
      this.render(Number(this.dataset.count || 0));
      this.refresh = () => loadCart().then(cart => this.render((cart.items || []).reduce((n, item) => n + (item.original_price > 0 ? item.quantity : 0), 0))).catch(() => {});
      this.events = ['cart:update','cart:updated','cart-update','cart:refresh'];
      this.events.forEach(name => document.addEventListener(name, this.refresh));
      window.addEventListener('pageshow', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.events?.forEach(name => document.removeEventListener(name, this.refresh));
      window.removeEventListener('pageshow', this.refresh);
    }
    render(count) {
      const message = this.querySelector('[data-bogo-message]');
      const progress = this.querySelector('[data-bogo-progress]');
      if (!message || !progress) return;
      if (count === 0) message.textContent = 'Choose any two bags. Enjoy half price on the lower-priced bag.';
      else if (count === 1) message.textContent = 'Add a second bag to enjoy 50% off the lower-priced bag.';
      else if (count % 2) message.textContent = 'Add one more bag to unlock another half-price bag.';
      else message.textContent = 'Your second bag is 50% off — automatically applied at checkout.';
      progress.style.width = count >= 2 ? '100%' : count === 1 ? '50%' : '0%';
    }
  }
  customElements.define('ma-bogo-offer', MaisonBogoOffer);
})();
